module.exports = __webpack_public_path__ + "img/zep3.efead05f.png";